document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
  if (bar.dataset.autoplay !== 'true') return;

  const items = bar.querySelectorAll('.announcement-bar__item');
  if (items.length < 2) return;

  const speed = (parseFloat(bar.dataset.speed) || 5) * 1000;
  let index = 0;

  setInterval(() => {
    items[index].hidden = true;
    index = (index + 1) % items.length;
    items[index].hidden = false;
  }, speed);
});
